import Vue from 'vue'
import Vuex from 'vuex'

import order from './order'
import settings from './settings'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    order,
    settings
  }
})
